import React, { useState, useContext } from 'react'
import { formatDate, ROUTES, formatNumber, isValidUrl } from '../../shared/constants'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useQuery, useQueryClient } from 'react-query'
import { axiosAuth, deleteDocumentById, getAllData } from '../../lib/RestApi/customApiHandler'
import useDebounce from '../../hooks/useDebounce'
import { UserContext } from '../../context api/UserContext'
import { Checkbox, IconButton, TableBody, TableCell, Edit } from '@material-ui/core'
import { FaFileInvoice } from 'react-icons/fa'
import PdfDialog from '../../components/Dialog/PdfDialog'
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import CustomDialog from '../../components/CustomDialog'
import HeadingWithCloseIcon from '../../components/HeadingWithCloseIcon'
import CustomHeading from '../../components/CustomHeading'
import CustomButton from '../../components/CustomButton'
import CustomInput from '../../components/CustomInput'
import { Avatar, Typography } from '@material-ui/core'
//? Material-ui
import LocalAtmIcon from '@material-ui/icons/LocalAtm'
import CheckIcon from '@material-ui/icons/Check'
import ClearIcon from '@material-ui/icons/Clear'
import {useFeatures} from '../../hooks/Features/useFeatures'
export default function AllowanceType() {
  const { user } = useContext(UserContext);
  const [searchQuery, setSearchQuery] = useState('')
  const [requests, setRequests] = useState([])
  const debouncedValue = useDebounce(searchQuery, 500)  
  const {getAllowanceRequestForSupervisor, supervisorRequests} = useFeatures();
  let { data: allowanceRequests, isLoading } = useQuery(['allowance-request', debouncedValue && debouncedValue], () => getAllData('/allowance/requests',  { searchQuery: debouncedValue, page: page, limit: limit, noOfpages: noOfPages }))
  const tableHeadings= user.position !== "KBC" ? ['Status', "Dates", "Travel Category", 'Amount', 'Remarks', "Images", 'Created At', 'Quote', `Action`] : ['Status', "Dates", "Travel Category", 'Amount', 'Remarks', "Images", 'Created At', 'Quote',]
  const queryClient = useQueryClient()
  const [report, setreport] = React.useState(true)
  const [reportDialog, setreportDialog] = React.useState(false)
  const [page, setPage] = React.useState(1)
  const limit = 45;
  const noOfPages = 100;
  const [popup, setPopup] = React.useState(false);
  const [amount, setAmount] = React.useState(0);
  const [id, setId] = React.useState(0);
  const handleAcceptRequest = async (id, data) => {
    // const response = await axiosAuth.put(`/update/allowanceRequest/${id}/accept`, body= {amount: amount})
    const response = await axiosAuth({
      method: 'PUT',
      url: `/update/allowanceRequest/${id}/accept`,
      data: {_id: id, approvedAmount: data && data},
    })
    console.log(response)
    setPopup(false);
    queryClient.invalidateQueries('allowance-request')
  }
  const handleRejectRequest = async (id, data) => {
    const response = await axiosAuth.put(`/update/allowanceRequest/${id}/reject`)
    console.log(response)
    queryClient.invalidateQueries('allowance-request')
  }

  const getRequests = async (id, data) => {
    // const response = await axiosAuth.put(`/update/allowanceRequest/${id}/accept`, body= {amount: amount})
    const response = await axiosAuth({
      method: 'PUT',
      url: `/update/allowanceRequest/${id}/accept`,
      data: {_id: id, approvedAmount: data},
    })
    console.log(response)
    setPopup(false);
    queryClient.invalidateQueries('allowance-request')
  }
  console.log("userRank", user)

  React.useEffect(()=>{
    if(user.position !== "KBC"){
      getAllowanceRequestForSupervisor();
    }
  }, [])

  React.useEffect(()=>{
  }, [id])

  React.useEffect(()=>{
    if(user.position !== "KBC"){
      setRequests(supervisorRequests);
    }else
    setRequests(allowanceRequests);
  }, [supervisorRequests, allowanceRequests ])
  let tmpArr = []
  if (!isLoading && requests?.data?.length > 0) {
    requests.data.map((item) => {
      return tmpArr.push([
        { type: 'CHECKBOX', _id: item?._id },
        { value: item?.status },
        { value: item?.date? formatDate(item.date) : formatDate(item.from) + " - " +  formatDate(item.to) },
        { value: item?.travelCategory?.name},
        { value: formatNumber(item?.amount) },
        { value: item?.remarks },
        { type: 'IMAGE', image: isValidUrl(item.images[0]) ? item.images[0] : "", profile : false },
        { value: formatDate(item.createdAt) },
        {
          value: (
            <>
            <IconButton 
              disabled = {item.report === undefined || item.report === ""}
              color="inherit" onClick={() => {
              setreport(item.report)
              setreportDialog(true)
            }}>
                <FaFileInvoice />
              </IconButton>   
          </>), 
            
        },
        {
          value: (
            user.position !== "KBC" ?  
             <>
              {item?.status === 'APPROVED' && <p>---</p>}
              {item?.status === 'DENIED' && <p>----</p>}
              {item?.status === 'IN-PROGRESS' && (
                <>
                <IconButton color="primary" aria-label="upload picture" component="span" onClick={() =>{
                   setPopup(true)
                   setId(item?._id)
                  }}>
                    <AttachMoneyIcon style={{ color: 'blue' }} />{' '}
                  </IconButton>
                  <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleAcceptRequest(item?._id, {})}>
                    <CheckIcon style={{ color: 'green' }} />{' '}
                  </IconButton>
                  <IconButton color="primary" aria-label="upload picture" component="span" onClick={() => handleRejectRequest(item?._id)}>
                    <ClearIcon style={{ color: 'red' }} />{' '}
                  </IconButton>
                </>
              )}
            </>: <> </>
            
          ),
        },
      ])
    })
  }
  const handlePageChange = (event, value) => {
    console.log("PAGE", value);
    setPage(value)
  }
  const layoutProps = {
    heading: 'Travel Allowance Requests',
    url: ROUTES.ADD_TRAVEL_REQUESTS,
    editUrl: '/travel-requests/edit/',
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    permissionName: "TRAVEL_ALLOWANCE",
    // tempHeaders: tempHeaders,
    // tempHeaderData: [],
    // filename: 'moduleAdmins',
    // sampleName: 'sample_moduleAdmins',
    // sheetName: 'moduleAdmin',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    // downloadLoading,
    setPage,
  }

  const deleteMany = async (ids) => {
    for await (let id of ids) {
      deleteDocumentById('delete/allowanceRequest', id)
    }
    queryClient.invalidateQueries('allowance-type')
  }

  return (
    <>
    <CustomTableLayout
      tableHeadings={tableHeadings}
      loading={isLoading}
      tableBody={tmpArr}
      popup = {popup}
      setPopup = {setPopup}
      // handleSwitchChange={handleSwitchChange}
      handlePageChange={handlePageChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => {
        deleteMany(val)
        setSelected([])
      }}
    />
    <PdfDialog open={report && reportDialog} handleClose={() => setreportDialog(false)} image={report} />
      <CustomDialog open={popup && true}
      handleClose={() => setPopup(false)}>
        <HeadingWithCloseIcon heading="Approve Amount" handleClose={() => setPopup(false)} />
        <>
          <CustomInput label="amount" value = {amount} handleChange= {(val)=>{
            setAmount(val)
          }}/>
          <CustomButton handleSubmit = {()=>handleAcceptRequest(id, amount)} text = "Approve" className= {{width: "20px"}}/>
        </>
      </CustomDialog>
    </>
    
  )
}
